<template>
    <div>
        <div id="bodyfilebox" class="bodyfile-container" style="height: calc(100vh - 110px); width: 100%">
            <iframe v-if="bodyFileUrl" id="pdfHtml" width="100%" height="100%" frameborder="0" scrolling="yes" :src="bodyFileUrl" />
            <div v-else style="text-align: center; padding-top: 200px">
                <svg style="font-size: 60px" data-v-5d08e6e2="" data-v-68e68533="" aria-hidden="true" class="nofile svg-icon"><use data-v-5d08e6e2="" xlink:href="#icon-word1" /></svg>
                <div v-text-lbl="'noAttach'" data-v-68e68533="" style="padding-top: 20px; padding-bottom: 30px; font-size: var(--portalFontSize13)">暂无附件</div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    components: {},
    props: {
        vo: {
            type: Object,
            default: function () {
                return {}
            }
        },
        canEdit: { type: Number, default: 0 }
    },
    data() {
        return {
            i18npkg: 'hygl',
            moduleCode: 'components',
            bodyFileUrl: ''
        }
    },
    computed: {},
    watch: {},
    created() {
        console.log('this.vo', this.vo)
        if (this.vo.passenger && this.vo.passenger.attachments && this.vo.passenger.attachments.length > 0) {
            this.vo.passenger.attachments.forEach((attach) => {
                if (attach.fileType === 'BODY' && attach.fileName.indexOf('.pdf') > -1) {
                    let fileurl = process.env.VUE_APP_BASE_API + `/htgl/htda/downloadById?inline=true&attachIds=${attach.id}` + '&widthType=auto&viewType=mobile'
                    fileurl += '&httpPort=' + location.port + '&fileName=' + attach.fileName + '&topdf=true'
                    this.bodyFileUrl = './plugins/PDFjs/web/viewer.html?file=' + encodeURIComponent(fileurl)
                }
            })
        }
    },
    beforeDestroy() {
        document.querySelector('.title-info').style.display = 'block'
        document.querySelector('.busi-components').style.padding = '0px 100px'
        document.querySelector('.busi-content').style.paddingBottom = '20px'
    },
    mounted() {
        document.querySelector('.title-info').style.display = 'none'
        document.querySelector('.busi-components').style.padding = '0px'
        document.querySelector('.busi-content').style.paddingBottom = '0px'
    },
    methods: {}
}
</script>

<style scoped lang="scss">
</style>
